import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId = z.any()
export type TagsDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId = z.infer<typeof tagsDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId>

export const descriptionDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId = z.any()
export type DescriptionDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId = z.infer<typeof descriptionDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId>

export const paramsDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId = z.object({ "municipalityId": z.string().uuid(), "documentId": z.string().uuid() })
export type ParamsDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId = z.infer<typeof paramsDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId>

export const responseDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId = z.any()
export type ResponseDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId = z.infer<typeof responseDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId>

interface IDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId extends BaseMethodType {
  tags: TagsDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId,
  description: DescriptionDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId,
  params: ParamsDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId,
  response: ResponseDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId
}
export const URL = '/documents/municipalities/:municipalityId/documents/:documentId'
export const validation = {
  delete: {
    tags: tagsDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId,
    description: descriptionDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId,
    params: paramsDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId,
    response: responseDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId
  }
}
export interface DocumentsMunicipalities_municipalityIdDocuments_documentId extends BaseRouteType {
  delete: IDeleteDocumentsMunicipalities_municipalityIdDocuments_documentId
}